import React, { useState } from 'react';
import { X, Plus, Search, ChevronRight, Pencil, ChevronUp, ChevronDown } from 'lucide-react';

const InterestsSection = ({ user }) => {
  const [showAll, setShowAll] = useState(false);
  const interests = user?.interests || [];
  const initialDisplayCount = 5;

  const displayedInterests = showAll ? interests : interests?.slice(0, initialDisplayCount);
  const hasMoreInterests = interests?.length > initialDisplayCount;

  if (!interests?.length) {
    return (
      <div className="bg-white rounded-lg shadow-lg p-6 w-full mx-auto mt-4">
        <h2 className="text-xl font-bold text-gray-900 mb-4">Interests</h2>
        <p className="text-gray-500 italic">No interests listed yet</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 w-full mx-auto mt-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold text-gray-900">Interests</h2>
        <span className="text-sm text-gray-500">{interests?.length} interests</span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2">
        {displayedInterests.map((interest) => (
          <div
            key={interest.id}
            className="flex items-center py-2 px-3 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors duration-200"
          >
            <div className="w-2 h-2 rounded-full bg-blue-500 mr-2"></div>
            <span className="text-gray-700 font-medium text-sm">{interest.name}</span>
          </div>
        ))}
      </div>

      {hasMoreInterests && (
        <button
          onClick={() => setShowAll(!showAll)}
          className="mt-4 flex items-center gap-1 text-blue-600 hover:text-blue-800 font-medium transition-colors duration-200 group"
        >
          {showAll ? (
            <>
              Show less
              <ChevronUp className="w-4 h-4 transition-transform group-hover:-translate-y-0.5" />
            </>
          ) : (
            <>
              Show all {interests?.length} interests
              <ChevronDown className="w-4 h-4 transition-transform group-hover:translate-y-0.5" />
            </>
          )}
        </button>
      )}
    </div>
  );
};

export default InterestsSection;